import React from "react";

const WidgetRow = ({ children, condition }) =>
  !condition ? null : <div className="widget-row">{children}</div>;
export default WidgetRow;
